<style>

    html, body {
        position: relative;
        height: 100%;
        font-size: 12px;
    }

    body:after {
        background-image: url(./../imgs/public_relation_bg_img_a.jpg);
    }

    .col-2-of-10 {
        float: left;
        width: 20%;
    }

    .col-3-of-10 {
        float: left;
        width: 30%;
    }

    .col-4-of-10 {
        float: left;
        width: 40%;
    }

    .swiper-container {
        width: 100%;
        height: 100%;
    }

    .box-size {
        height: 150px;
        width: 150px;
    }

    .white-box-size {
        height: 75px;
        width: 375px;
        margin-top: 50px;
    }

    .title-size {
        font-size: 14px;
    }

    .content-size {
        font-size: 12px;
    }

    .bg-image {
        background-position: center;
        background-size: cover;
        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
    }

    @media (min-width: 992px) {

        .box-size {
            height: 150px;
            width: 150px;
        }

        .white-box-size {
            height: 75px;
            width: 375px;
            margin-top: 37.5px;
        }

        .title-size {
            font-size: 14px;
        }

        .content-size {
            font-size: 12px;
        }
    }

    @media (min-width: 1200px) {

        .box-size {
            height: 200px;
            width: 200px;

        }

        .white-box-size {
            height: 100px;
            width: 500px;
            margin-top: 50px

        }

        .title-size {
            font-size: 20px;
        }

        .content-size {
            font-size: 16px;
        }

    }


    .officePhoneXs {
        background-color: #FFFFFF;
        padding: 15px 15px 15px 15px;
        margin: 15px 0px 15px 0px;
        width: 100%;
        height: 100%;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.50);
    }

    .xcx{ display: block; width: 100%; margin-top: 20px;}
    .xcx .box{ float: left; width: 50%;}
    .xcx .box img{ width: 80%; margin: 0 10%;}
    .xcx .box h3{ text-align: center; font-size: 18px; font-weight: bold;}
    .tie{ background-color: #FFFFFF; padding: 40px 10px 10px 20px;}
    @media (max-width: 992px) {
        .xcx .box{ float: left; width: 100%; margin-bottom: 30px;}
        .tie{ padding: 20px 0 10px 0;}
    }
</style>

<template>

    <div class="container">

        <!--标题-->
        <div class="tx-page-title">
            {{ $t("Contact_title") }}
        </div>
        <div class="tx-page-subtitle">
            {{ $t("Contact_content") }}
        </div>

        <!--内容-->
        <div style="margin: 0 20px;">
            <div class="col-sm-12" style="display: inline-block; background-color: white;padding:15px;margin-bottom: 100px;border-right: solid #e4ab34 10px;box-shadow: 0 2px 4px rgba(0,0,0,0.50)">
                <!-- <div id="officePics-desktop" class="col-xs-12 col-sm-12 col-md-7 col-lg-7" style="padding: 0px">
                    <img src="imgs/lxwm.jpg" class="col-xs-12" style="cursor: pointer; padding: 0px">
                </div> -->
                <div id="officePics-desktop" class="col-xs-12 col-sm-12 col-md-7 col-lg-7" style="padding: 0px">
                    <img src="imgs/x_1.jpg" class="col-xs-6" style="cursor: pointer; padding: 0px">
                    <img src="imgs/x_2.jpg" class="col-xs-6" style="cursor: pointer; padding: 0px">
                    <img src="imgs/x_3.jpg" class="col-xs-6" style="cursor: pointer; padding: 0px">
                    <img src="imgs/x_4.jpg" class="col-xs-6" style="cursor: pointer; padding: 0px">
                </div>
                <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5" style="padding: 0px">
                    <div class="tie">
                        <div class="title-size" style="color: #4A4A4A;">
                            {{ "联系地址：中国广州番禺区南站喜街" }}
                        </div>
                        <div class="content-size" style="color: #9B9B9B;">
                            {{ "联系电话：020-88834737" }}
                        </div>
                        <div class="xcx">
                            <div class="box">
                                <img src="imgs/gzh_qr.jpg" alt="同熙商业公众号">
                                <h3>同熙商业公众号</h3>
                            </div>
                            <div class="box">
                                <img src="imgs/xcx_qr.jpg" alt="玩转喜街小程序">
                                <h3>玩转喜街小程序</h3>
                            </div>
                        </div>
                        <!-- <div class="content-size" style="color: #9B9B9B;">
                            {{ $t("fax_GZ") }}
                        </div>
                        <div class="content-size" style="color: #9B9B9B;">
                            {{ $t("email_GZ") }}
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    module.exports = {
        data: function () {
            return {
                testWording: "Hi Ivon is here~~"
            }
        },
        mounted: function () {

            $('#officePics-mobile').viewer({
                toolbar: false,
                navbar: false,
                title: false
            });

            $('#officePics-desktop').viewer({
                scalable: false,
                title: false,
                url: 'data-original'
            });
            window.pageTitle = {
                en_US: this.$i18n.messages.en_US.page_title_contact,
                zh_HK: this.$i18n.messages.zh_HK.page_title_contact,
                zh_CN: this.$i18n.messages.zh_CN.page_title_contact
            }
            window.setTitle(window.pageTitle[this.$i18n.locale]);
        }

    }

</script>


// WEBPACK FOOTER //
// contact.vue?67723860